'use strict';

import moment from 'moment'
import {filter} from 'lodash'

var handlebars = require('handlebars');
var sampleReviews = require('./sampleReviews');

handlebars.registerHelper('abbreviatedLastName', function(fullName) {
  const names = fullName.split(" ")
  const lastInitial = names.length > 1 ?  (" " + names[names.length - 1].split("")[0].toUpperCase() + ".") : ""
  const processedName = names.slice(0, names.length - 1).join(" ") + lastInitial
  return processedName
});

handlebars.registerHelper('ifEqual', function(item1,item2,options) {
  return item1 === item2 ? options.fn(this) : ""
});

handlebars.registerHelper('ifNotEqual', function(item1,item2,options) {
  return item1 !== item2 ? options.fn(this) : ""
})

handlebars.registerHelper('ifEmptyOrNull', function(item,options) {
  return !item || item == "" ? options.fn(this) : ""
})

handlebars.registerHelper('formatDate', function(rawDate) {
  return moment(rawDate,'M/D/YYYY').format('MMMM Do YYYY')
})

handlebars.registerHelper('round', function(rating) {
  return Math.round(rating)
})

handlebars.registerHelper('toLowercase', function(text) {
  return text.toLowerCase()
})

handlebars.registerHelper('ifNotReviewBuilder', function(text,options) {
  return options.fn(this)
})

handlebars.registerHelper('ifGreater', function(item1,item2,options) {
  return item1 > item2 ? options.fn(this) : ""
})



export default function(angularModule) {
  angularModule.controller('WidgetEditorCtrl', function($q, $scope, $state, pageInfo, $stateParams, reviewGenService,
      $log, stringService, updateService, accountsService, $timeout, $sce, $templateCache, $location, $uibModal, providerService, userService,
      isSharedDefault, user
  ) {
    var vm = this;
    vm.mode = pageInfo.mode;
    vm.accountConfig = {
      required: true,
      accountId: null,
      disableDropdown: vm.mode == "edit",
      showAccountSelection: false,
      editPage: true
    };
    vm.showVisibility = isSharedDefault || _.includes(user.permissions, 'ReviewBuilderVisibilityAdmin');

    vm.getCurrentTemplate = function() {
      if(vm.selectedTab == "Html"){
        return vm.widget.template;
      }
      else if(vm.selectedTab == "Embed"){
        generateEmbedCode();
        return(vm.embedCode);
      }
    };

    vm.colorSchemes = require('../../../../common/data/themes');

    vm.selectTab = function(type) {
      vm.selectedTab = type;
    };

    vm.fontSizes = [];

    for (var x = 10; x < 30; x++) {
      vm.fontSizes.push(x.toString() + "px");
    }


    vm.widgetOptions = {
      colorScheme: "",
      backgroundColor: "#ddd",
      foregroundColor: "#fff",
      paragraphSize: "13px",
      paragraphColor: "#ddd",
      titleSize: "20px",
      titleColor: "#666",
      css: ""
    };

    vm.state = 'Loading'

    function initWidget(widget) {
      vm.state = "WidgetEditing";
      if (vm.mode == 'create') {
        delete widget._id;
        widget.isShared = isSharedDefault;
      }
      if ($stateParams.copy) {
        widget.name = `Copy of ${widget.name}`;
      }
      vm.widget = widget;
      if (vm.widget.accountId) {
        vm.accountConfig.accountId = vm.widget.accountId
      }

      if (widget.theme) {
        vm.colorScheme = _.find(vm.colorSchemes, {id: widget.theme});
      }
    }

    vm.onEditorLoaded = function (editor) {
      editor.setTheme("ace/theme/chrome");
      editor.getSession().setMode("ace/mode/handlebars");
      editor.setShowPrintMargin(false);
      editor.$blockScrolling = Infinity;
      vm.editor = editor;
    };

    vm.pageStrings = stringService.adminStrings(vm.mode);

    function processSuccessfulAddWidget(response) {
      vm.newWidget = response.data;

      var updateInfo = {
        status: "Active",
        type: "widget",
        title: "Widget",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: vm.mode}],
        entity: vm.newWidget,
        id: vm.newWidget._id,
        name: vm.newWidget.name,
        accountId: accountsService.getCurrentAccount(),
        searchParam: vm.newWidget.widgetName
      };
      updateService.registerSuccessfulUpdate(updateInfo, true);

      let currentStateName = $state.current.name;
      let modalInstance = $uibModal.open({
        template: require('./confirmationModal.html'),
        controller: ["$scope",function($scope) {
          $scope.newWidget = response.data;
          $scope.featureTags = vm.newWidget.featureTags ? vm.newWidget.featureTags : false;
        }]
      });
      modalInstance.closed.then(res => {
        if ($state.current.name === currentStateName) {  // If we still haven't left the page, redirect to widget list
          $state.go('reviewBuilder.widgets.list');
        }
      });
      $scope.$on('$stateChangeStart', event => {
        modalInstance.close();
      });


      vm.state = 'Success';
    }

    function handleError(response) {
      var errorDetail = 'Please contact support';

      if (response.data && response.data.error.code) {
        var errorCode = response.data.error.code;

        if (errorCode == 'widget.edit.widgetName.duplicate') {
          errorDetail = 'This Widget name already exists. Widget names must be unique.';
        }
      }

      vm.errorMsg = 'Error ' + vm.pageStrings.errorAction + ' Widget!';
      vm.errorDetail = errorDetail;
      vm.state = 'WidgetEditing';
    }


    vm.createEditWidget = function (isWidgetValid) {
      vm.state = 'PendingConfirmation';
      vm.formSubmitted = true;

      if (!isWidgetValid) {
        $log.info('Missing Widget data');
        return;
      }

      if(vm.widget.minRating){
        vm.widget.minRating = parseInt(vm.widget.minRating);
      }
      else{
        delete vm.widget.minRating;
      }

      vm.widget.widgetType = "review";

      if(!vm.widget.maxReviews){
        delete vm.widget.maxReviews;
      }

      if (vm.mode == "create") {
        reviewGenService.addWidget(vm.widget).then(processSuccessfulAddWidget).catch(handleError);
      }
      else {
        reviewGenService.updateWidget(vm.widget).then(processSuccessfulAddWidget).catch(handleError);
      }
    };


    vm.defaultWidget = {
      accountId: "123",
      deleted: false,
      name: "default",
      template: "",
      maxReviews: null,
      minRating: null,
      theme: "",
      widgetType: vm.type
    };

    vm.updateMaxReviews = function (opType) {
      if(opType == "+") {
        vm.widget.maxReviews++
      }
      else { //opType == "-"
        vm.widget.maxReviews--
      }
      updatePreview();
    };

    vm.cancel = function () {
      $state.go("^");
    };

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    activate();

    function activate() {
      vm.state = 'Loading';
      vm.formSubmitted = false;
      if (vm.mode == "create") {
        vm.accountConfig.accountId = accountsService.getCurrentAccount();
      }
      if ($state.params.widget) {
        initWidget($stateParams.widget);
      } else if ($state.params.widgetId) {
        reviewGenService.getWidget($state.params.widgetId).then(response => initWidget(response.data));
      } else {
        reviewGenService.getFirstReview().then(function(response) {
          vm.defaultWidget.template = response.data.template
          initWidget(vm.defaultWidget);
        });
      }
    }

    vm.updateTheme = function () {
      vm.widget.theme = vm.colorScheme.id;
      var doc = new DOMParser().parseFromString(vm.widget.template, "text/html");
      var styleNode = doc.head.querySelector('#injected-style') || doc.createElement("style");
      styleNode.id = "injected-style";
      styleNode.type = 'text/css';
      if (styleNode.styleSheet) {
        styleNode.styleSheet.cssText = vm.colorScheme.style;
      } else {
        styleNode.innerHTML = vm.colorScheme.style;
      }
      doc.body.id = "templateBody";       // Strengthen the selectors to override existing rules
      doc.head.appendChild(styleNode);

      vm.widget.template = `<!DOCTYPE html>
      <html>
          <head>${doc.head.innerHTML}</head>
          <body>${doc.body.innerHTML}</body>
      </html>`;
    };


    vm.updatePreview = _.debounce(updatePreview, 500);
    function updatePreview() {
      let reviews = sampleReviews(vm.widget.minRating, vm.widget.maxReviews)
      let summary = {
        avgRating: 4.4,
        count: 1731,
        countByRating: [
          {rating: 5, total: 829},
          {rating: 4, total: 759},
          {rating: 3, total: 89},
          {rating: 2, total: 45},
          {rating: 1, total: 9}
        ],
        percentRecommended: 91,
        reviewUrl: '#'
      }

      summary.percentRecommended = Math.round( 100 * filter(summary.countByRating, item => (item.rating > 3)).reduce((acc,val) => (acc + val.total),0)/summary.count)
      const highestTotal = summary.countByRating.reduce((acc,val) => (val.total > acc ? val.total : acc),0)
      summary.countByRating.forEach(item => item.chartPercentage = Math.ceil(100 * item.total/highestTotal))

      var template = handlebars.compile(vm.widget.template);

      var iframe = $("#previewWrapper")[0], iframedoc = iframe.contentDocument || iframe.contentWindow.document;

      iframedoc.open();
      iframedoc.write(template({reviews, summary}));
      iframedoc.close();
    }


    vm.triggerEditorRefresh = function(template){
      if(template){
        vm.editor.setValue(template);
        generateEmbedCode();
      }
    };

    $scope.$watch('vm.accountConfig.accountId', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        vm.widget.accountId = newVal;
      }
    });

  })
};
